import {StudentAdminContainer} from "../StudentAdmin.styled";
import {ImageContainer, UserName} from "./Student.styled";
import { useI18n } from '@i18n/useI18n';
import StudentThumbnail from "@components/StudentThumbnail";


interface IProps{
    studentInfo:any;
}

const RedeemStudent = (props:IProps) =>{
    const i18n = useI18n();

    return (
        <StudentAdminContainer>
            <ImageContainer>
                <StudentThumbnail top={"-5%"} regView={true} font={"6em"} name={props.studentInfo.name} src={props.studentInfo.username} />
                <UserName>
                    {props.studentInfo.name}
                </UserName>
            </ImageContainer>
        </StudentAdminContainer>
    )
}

export default RedeemStudent;